export default {
  client_users: [],
  client_role_types : [],
  autocomplete_data : [],
  autocomplete_selected : {},
  verticals : [],
  vertical_selected : {},
  countries : [],
  countries_selected : {},
  head_office_country_selected : {},
  client_user:[],
  selected_client_user : {},
}
